import React from 'react';
import PropTypes from 'prop-types';

import UserIcon from "core/gd-components/icons/user/user";

export default function UsersMultiselectOptionPill(props) {
    if (!props.userId) return false;

    const onDelete = (e) => {
        e.stopPropagation();
        if(props.onDelete) props.onDelete(props.userId);
    }

    const pillClasses = Classes("ui5-pillbox", "fl-ac", "fl-no-shrink", props.className);

    const optionStyle = {
        // minHeight: 24,
        overflow: 'hidden', //required for txt-truncate to work correctly
    };

    const user = gd.session.users.get(props.userId);

    return (
        <div className={pillClasses} style={props.style}>
            <div className="ui5-txt-less-important-small fl-ac m-t-4 m-b-4 m-l-5 m-r-5" style={optionStyle}>
                <UserIcon className="m-r-8" userId={user.id} size="22"/>
                <div className="ui5-txt-default txt-truncate lh-20">{user.name}</div>
            </div>

            {props.onDelete && <div className="delete-button centered ui5-ico-delete s14 gray" onClick={onDelete}/>}
        </div>
    );
}

UsersMultiselectOptionPill.propTypes = {
    userId: PropTypes.string,

    onDelete: PropTypes.func
}